import { useTheme } from "@emotion/react";
import { Button, colors, IconButton, ListItemText, MenuItem, SxProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { MiscSavio, StyleguideSavioColors, StyleguideSavioFonts } from "../../../../configuration/themeSettings";

export const MenuItemCountryStyled = styled("span", { label: "AppBrandMenu-country" })(
    ({ theme }) => ({
        fontWeight: StyleguideSavioFonts.normal,
        fontSize: 9,
        marginTop: -5,
    })
);

export const AppBrandMenuIcon = styled(IconButton, { label: "AppBrandMenu-icon" })(
    ({ theme }) => ({
       marginRight:0 + ' !important',
       "&.Mui-disabled": {
        color: "inherit",
    }
    })
);

export const MenuItemStyled = styled(MenuItem, { label: "AppBrandMenu-li" })(
    ({ theme }) => ({
        display: "flex", 
        height: 60,
        alignItems: "center",
        color: theme.palette.primary.main,
        fontWeight: StyleguideSavioFonts.bold,
        borderBottom: '1px solid ' + StyleguideSavioColors.lightGrey,

        "&.selected":{
            backgroundColor: MiscSavio.hoverBackgroundTable,
            color: theme.palette.primary.contrastText,
        },

        "&:hover":{
            backgroundColor: MiscSavio.hoverBackgroundTable,
            color: theme.palette.primary.contrastText,
        },

        "> div": {
            display: 'flex',
            "svg": {
                fontSize: 14,
                marginRight: 3,
                marginTop:5,
            },
            "> div": {
                display: 'flex',
                flexDirection: 'column',
            }
        }
    })
);